import { workListChanged } from 'actions/action-patient';
import { editFillDeliveryConfirmation, updateFdcStatusForPrintedOrder } from 'actions/action-tasks';
import { TaskStatus } from 'interfaces/enums/TaskStatus';
import { FillDeliveryConfirmationStatus } from 'interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { TaskTypesEnum } from 'constants/enums';
import { IPrintLabelButton } from './types';

export const updateFdcStatus = ({
  data,
  dispatch,
  setStatus,
  setCurrentStatus,
}: IPrintLabelButton) => {
  if (data?.status_id === FillDeliveryConfirmationStatus.Dispense) {
    const new_statusId = FillDeliveryConfirmationStatus.Packed;
    const new_taskStatusText = TaskStatus.Packed;
    const taskType = TaskTypesEnum.FDC.toLowerCase();

    const updatedTask = {
      id: data.id,
      taskType,
      therapy_id: data.therapy_id,
      status_id: new_statusId,
      task_status_text: new_taskStatusText,
    };

    if (dispatch) {
      dispatch(editFillDeliveryConfirmation(updatedTask));
      dispatch(updateFdcStatusForPrintedOrder(updatedTask));
      dispatch(workListChanged());
    }

    if (setStatus) {
      setStatus(new_taskStatusText);
    }

    if (setCurrentStatus) {
      setCurrentStatus(updatedTask.status_id);
    }
  }
};
